import React from "react";
import AccessoriesInner from "../../categoryinnerpage";
import SEO from "../../seo";

export default function HeadBoardsPage() {
  const categoryName = "Head Boards";
  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board4.jpg",
      name: "Boston",
      description: "",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board3.jpg",
      name: "Ritz",
      description: "",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board2.jpg",
      name: "Toree",
      description: "",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Head-Board.jpg",
      name: "Windsor",
      description: "",
    },
  ];

  const categoryDescription =
    "Realise your dreams of luxury interiors with handcrafted head boards and bed frames. Reach out to us today to custom select from a range of colours, styles, sizes and finishes to suit you.";
  return (
    <div>
      <SEO
        title="Head Boards | Accessories | Eclipse International"
        description="Excellent craftsmanship and finest materials for a luxurious sleep experience- and upgrade your bed and bedroom today."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <AccessoriesInner
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
